/* eslint-disable */

import { find, escape as _escape, unescape as _unescape } from "lodash";
import { inlineEditResx } from "../resxDist/inlineEditResx";

(function ($) {
    /*
    This is a modified version of Chosen
    Chosen, a Select Box Enhancer for jQuery and Protoype
    by Patrick Filler for Harvest, http://getharvest.com
  
    Available for use under the MIT License, http://en.wikipedia.org/wiki/MIT_License
  
    Copyright (c) 2011 by Harvest
    */
    var SelectParser;
    var __bind = function (fn, me) {
        return function () {
            return fn.apply(me, arguments);
        };
    };

    var nsCounter = 0;

    $.widget("ep.combobox", {
        options: {
            disabled: false,
            customScroll: false,
            customScrollCssMarker: "custom-scroll",
            setTabIndex: true,
            focusOnInit: false,
            width: null,
            minDropDownWidth: 250,
            spaceBetween: null,
            showInputForQuickSearch: true,
            inlineQuickSearch: false,
            //note: temporary flag which indicates that dropdown container should be displayed before input if input displayed on the bottom of the page
            // todo : make this default behaviour and remove this option at all (but we need test all places where this control is used)
            adjustDropdownContainer: false,
            viewport: null,
            getViewportTop: null,
            showInput: true, // currently it works only for single select mode
            showDrop: true,
            addCreationField: false,
            lengthNewField: null,
            onShow: null,
            onHide: null,
            showResultsOnStart: false,
            noResultsOverflowHidden: false,
            hideDropdownBeforeAdd: false,
            responsiveWidth: false,
            resources: {
                keepTyping: inlineEditResx.Combobox_KeepTyping,
                noResults: inlineEditResx.Combobox_NoResults,
                noResultsMatch: inlineEditResx.Combobox_NoResultsMatch,
                add: inlineEditResx.Combobox_Add,
                multipleSelectDefault: inlineEditResx.Combobox_MultipleSelectDefault,
            },
            initialSearchText: '',
            placeHolderOptions: { },
            isScrollableWindow: true,
            showSelectedItemTitle: false,
        },
        _create: function () {
            this.set_default_values();
            this.form_field_jq = this.element;
            this.form_field = this.element[0];
            this.is_multiple = this.form_field.multiple;
            this.default_text_default = this.form_field.multiple ? this.options.resources.multipleSelectDefault : "";
            this.set_up_html();
            this.set_initial_focus();
            this.register_observers();

            this.testClickNs = ".selecttestclick" + nsCounter++;

            if (this.options.showResultsOnStart) {
                this.toogle_and_activate();
            }
        },
        
        set_initial_focus: function() {
            if (this.options.focusOnInit && this.selected_item) {
                this._focus_handler_stopped = true;
                this.selected_item.focus();

                // hack for ie becasue it triggers focus event with delay
                // but after this delay control has subscription for focus event and open dropdown in this callback
                // to set focus only (and avoid "autoopening") -> stop this handler for 500ms
                var self = this;
                setTimeout(function() {
                    self._focus_handler_stopped = false;
                }, 500);
            }
        },

        set_default_values: function () {
            this.click_test_action = __bind(function (evt) {
                return this.test_active_click(evt);
            }, this);
            this.active_field = false;
            this.mouse_on_container = false;
            this.results_showing = false;
            this.result_highlighted = null;
            this.result_single_selected = null;
            return this.choices = 0;
        },
        set_up_html: function () {
            var container_div, dd_top, sf_width, select_width;
            this.container_id = this.form_field.id.length ? this.form_field.id.replace('.', '_') : this.generate_field_id();
            this.container_id += "_chzn";
            if (this.options.width == 'auto' || this.options.width == "notrestrictedauto") {

                this.f_width = this.form_field_jq.width();

                select_width = this.options.responsiveWidth ? 'width: 100%' : 'width: auto;' + (this.options.width == 'auto' ? 'max-width:' + this.options.minDropDownWidth + 'px' : '');
            } else {

                this.f_width = this.options.width || this.form_field_jq.width();
                select_width = 'width: ' + this.f_width + 'px;';
            }
            this.default_text = this.form_field_jq.attr('title') ? this.form_field_jq.attr('title') : this.default_text_default;
            container_div = $("<div />", {
                id: this.container_id,
                "class":this.options.customScroll ? 'chzn-container ' + this.options.customScrollCssMarker : 'chzn-container',
                style: select_width,
                tabindex: -1
            });

            this.addButtonHtml = '';

            if (this.is_multiple) {
                container_div.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" style="width:25px;" /></li></ul><div class="chzn-drop" style="display: none;"><ul class="chzn-results"></ul></div>');
            } else {
                var maxLenght = this.options.lengthNewField != null?
                'maxlength ="' + this.options.lengthNewField + '" ' : '';
                var searchInputEl = '', searchInputInline = '';
                
                if (this.options.inlineQuickSearch) {
                    var searchInputInline = '<div class="chzn-single-active" style="display:none" ><input type="text" class="chzn-inline-search text-input" autocomplete="off" ' + maxLenght + '  /></div>';
                } else {
                    searchInputEl = '<div class="chzn-search" ' + (!this.options.showInputForQuickSearch ? 'style="display:none"' : "") + ' ><input type="text" autocomplete="off" placeholder="' + this.default_text + '"  ' + maxLenght + '  /></div>';
                }

                this.addButtonHtml = this.addingEnabled() ? '<li class="chzn-add active-result"></li>' : '';

                const selectedItemText = this._getSelectedItemText(this.default_text);
                container_div.html('<a onclick="return false" class="chzn-single" ' + (!this.options.showInput || !this.options.showDrop ? 'style="display:none"' : "") + '>' +
                                        '<span' + (this.options.showSelectedItemTitle ? ' title="' + selectedItemText + '"' : '') + '>' + selectedItemText + '</span>' +
                                        '<div><b></b></div>' +
                                    '</a>' +
                                    searchInputInline +
                                    '<div class="chzn-drop" style="display: none;">' +
                                        searchInputEl +
                                        '<ul class="chzn-results"></ul>' +
                                    '</div>');
            }

            if (this.options.customScroll) {
                /// TODO : extract markup and unify

                this.scrollbar = container_div.find("ul").customScrollbar();

            }

            container_div.addClass(this.element.data("class") || "");

            this.form_field_jq.hide().after(container_div);
            this.container = $('#' + this.container_id);
            this.container.addClass("chzn-container-" + (this.is_multiple ? "multi" : "single"));
            this.dropdown = this.container.find('div.chzn-drop').first();
            dd_top = this.container.height();
            this.dd_width = (this.f_width < this.options.minDropDownWidth ? this.options.minDropDownWidth : this.f_width) - $.ep.combobox.get_side_border_padding(this.dropdown);
            this.dropdown.css({
                "width": this.dd_width + "px",
                "top": dd_top + "px"
            });
            this.search_field = this.container.find('input').first();
            this.search_results = this.container.find('ul.chzn-results').first();
            this.add_button = $(this.addButtonHtml);
            this.search_field_scale();
            if (this.is_multiple) {
                this.search_choices = this.container.find('ul.chzn-choices').first();
                this.search_container = this.container.find('li.search-field').first();
            } else {
                this.search_container = this.container.find('div.chzn-search').first();
                this.selected_item = this.container.find('.chzn-single').first();
                this.selected_item_active = this.options.inlineQuickSearch ? this.container.find(".chzn-single-active:first") : $();
                if (!this.options.inlineQuickSearch) {
                    sf_width = this.dd_width - $.ep.combobox.get_side_border_padding(this.search_container) - $.ep.combobox.get_side_border_padding(this.search_field);
                    this.search_field.css({
                        "width": sf_width + "px"
                    });
                }
            }
            this.results_build();
            this.checkDisabled();
            this.set_up_html_override();
            if (this.options.setTabIndex) {
                return this.set_tab_index();
            }
        },

        _getSelectedItemText: function(text) {
            var resText = '';
            if (this.options.resources.selectedItemTextPrefix) {
                resText = this.options.resources.selectedItemTextPrefix;
            }

            return resText + text;
        },

        set_text_to_search:function (value) {
            this.search_field.val(value);
            this.results_search_do();
            this.result_do_highlight(this.search_results.find("li.active-result").first());
        },
        
        set_up_html_override:function() {
            
        },
        
        getDropDown: function(){
            return this.dropdown;
        },

        register_observers: function () {
            /// TODO: Rewrite from __bind to $.proxy
            this.container.mousedown(__bind(function (evt) {
                return this.container_click(evt);
            }, this));
            this.container.mouseenter(__bind(function (evt) {
                return this.mouse_enter(evt);
            }, this));
            this.container.mouseleave(__bind(function (evt) {
                return this.mouse_leave(evt);
            }, this));
            this.search_results.click(__bind(function (evt) {
                return this.search_results_click(evt);
            }, this));
            this.search_results.mouseover(__bind(function (evt) {
                return this.search_results_mouseover(evt);
            }, this));

            this.search_results.mouseout(__bind(function (evt) {
                return this.search_results_mouseout(evt);
            }, this));
            this.form_field_jq.bind("liszt:updated", __bind(function (evt) {
                return this.results_update_field(evt);
            }, this));
            this.form_field_jq.bind("liszt:enableupdated", __bind(function () {
                return this.checkDisabled();
            }, this));
            this.form_field_jq.bind("liszt:valueupdated", __bind(function (evt) {
                return this.update_selected_value_from_form_field(evt);
            }, this));

            this.form_field_jq.on('no-result', __bind(function (evt) {
                if (this.options.hideDropdownBeforeAdd)
                this.dropdown.hide();
            }, this));

            this.search_field.blur(__bind(function (evt) {
                return this.input_blur(evt);
            }, this));
            this.search_field.keyup(__bind(function (evt) {
                return this.keyup_checker(evt);
            }, this));
            this.search_field.keydown(__bind(function (evt) {
                return this.keydown_checker(evt);
            }, this));
            this.search_field.on('paste', __bind(function (evt) {
                return this.results_search();
            }, this));
            this.search_field.mousedown(__bind(function (evt) {
                evt.stopPropagation();
            }, this));

            if (this.is_multiple) {
                this.search_choices.click(__bind(function (evt) {
                    return this.choices_click(evt);
                }, this));
                this.search_field.focus(__bind(function (evt) {
                    return this.input_focus(evt);
                }, this));
            } else {
                if (!this.options.showInputForQuickSearch) {
                    
                    this.container.keyup(__bind(function (evt) {
                        return this.keyup_checker(evt);
                    }, this));

                    this.container.keydown(__bind(function (evt) {
                        return this.keydown_checker(evt);
                    }, this));

                    this.selected_item.blur(__bind(function (evt) {
                        return this.input_blur(evt);
                    }, this));
                }               

                this.selected_item.focus(__bind(function (evt) {
                    if (this._focus_handler_stopped)
                        return;

                    //open dropdown only if it's closed right now
                    if (!this.active_field && !this.results_showing)
                        return this.container_click(evt);
                }, this));
            }

            if (this.options.customScroll) {
                this.scrollbar.on("mousedown", ".scrollbar", function (event) {
                    event.preventDefault();
                });
            }
        },

        addingEnabled: function() {
            return this.options.addCreationField && this.options.showInputForQuickSearch;
        },

        checkDisabled: function (onlyTest) {
            var disabled = this.form_field_jq.prop('disabled') || this.options.disabled;
            if (!onlyTest) {
                if (disabled) {
                    this.container.addClass('disabled');
                } else {
                    this.container.removeClass('disabled');
                }
            }

            return disabled;
        },
        container_click: function (evt) {
            if (evt) {
                evt.preventDefault();
            }

            if (this.checkDisabled()) {
                return;
            }

            if (this.pending_destroy_click) {
                this.pending_destroy_click = false;
                return false;
            }

            if (!this.active_field && !this.results_showing
                || (!this.is_multiple && evt && (evt.target === this.selected_item[0] || $(evt.target).parents("a.chzn-single").length))) {
                this.toogle_and_activate(evt);
            }
        },
        toogle_and_activate: function (evt) {
            var self = this;
            if (!this.active_field && !this.results_showing) {
                if (this.is_multiple) {
                    this.search_field.val("");
                }

                $(document).on("mousedown" + self.testClickNs + " epclickstopped" + self.testClickNs, self.click_test_action);
                
                this.results_show();
            }
            else {
                this.results_toggle(evt);
            }

            this.activate_field();
        },
        mouse_enter: function () {
            return this.mouse_on_container = true;
        },
        mouse_leave: function () {
            return this.mouse_on_container = false;
        },
        input_focus: function (evt) {
            if (!this.active_field) {
                return setTimeout((__bind(function () {
                    return this.container_click();
                }, this)), 50);
            }
        },
        input_blur: function (evt) {
            if (!this.mouse_on_container) {
                this.active_field = false;
                return setTimeout((__bind(function () {
                    return this.blur_test();
                }, this)), 100);
            }
        },
        blur_test: function (evt) {
            if (!this.active_field && this.container.hasClass("chzn-container-active")) {
                return this.close_field();
            }
        },
        close_field: function () {

            if (this._subscribe_click_test_timeout) {
                clearTimeout(this._subscribe_click_test_timeout);
            }
            $(document).off(this.testClickNs);


            if (this.options.setTabIndex) {
                if (!this.is_multiple) {
                    if (this.options.showInputForQuickSearch) {
                        this.selected_item.attr("tabindex", this.search_field.attr("tabindex"));
                        this.search_field.attr("tabindex", -1);
                    }
                }
            }
            
            this.active_field = false;
            this.results_hide();
            this.container.removeClass("chzn-container-active");
            this.winnow_results_clear();
            this.clear_backstroke();
            this.show_search_field_default();
            return this.search_field_scale();
        },
        activate_field: function () {
            if (this.options.setTabIndex) {
                if (!this.is_multiple && !this.active_field) {
                    if (this.options.showInputForQuickSearch) {
                        this.search_field.attr("tabindex", this.selected_item.attr("tabindex"));
                        this.selected_item.attr("tabindex", -1);
                    }
                }
            }
            
            this.container.addClass("chzn-container-active");

            this.active_field = true;

            if (document.activeElement !== this.search_field[0]) {
                this.search_field.val(this.search_field.val());
                /*
                // bug 10042 IE 9: Add time log\Weekly view: it is impossible to change activity
                // after 2 or more post back don't work click by triangle 

                // this.search_field.focus();
                */
            }

            return true;
        },
        test_active_click: function (evt) {
            if ($(evt.target).parents('#' + this.container_id).length) {
                return this.active_field = true;
            } else {
                return this.close_field();
            }
        },
        results_build: function () {
            var content, data, _i, _len, _ref, selected_item;
            this.results_data = SelectParser.select_to_array(this.form_field);
            if (this.is_multiple && this.choices > 0) {
                this.search_choices.find("li.search-choice").remove();
                this.choices = 0;
            } else if (!this.is_multiple) {
                const selectedItemText = this._getSelectedItemText(this.default_text);
                this.selected_item.find("span").text(selectedItemText);
                if (this.options.showSelectedItemTitle) {
                    this.selected_item.find("span").attr("title", selectedItemText);
                }
            }
            content = '';
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                data = _ref[_i];
                if (data.group) {
                    content += this.result_add_group(data);
                } else if (!data.empty) {
                    content += this.result_add_option(data);
                    if (data.selected && this.is_multiple) {
                        this.choice_build(data);
                    } else if (data.selected && !this.is_multiple) {
                        selected_item = data;

                        this.set_selectedText(data);
                    }
                }
            }

            this.show_search_field_default();
            this.search_field_scale();
            this._setContent(content, false);
            
            if (selected_item) {
                this.result_single_selected = $('#' + selected_item.dom_id);
            }

            //set the lastSearchText value to empty string for not to initiate the search on first loading
            this.lastSearchText = "";
            this.element.trigger("content_changed");
            return false;
        },
        
        _setContent: function(content, showAddButton) {
            this.search_results.html(content);

            if (showAddButton)
                this.search_results.prepend(this.add_button);

            this.element.trigger("content_changed");
        },

        result_add_group: function (group, label) {
            //if (!group.disabled) {
            group.dom_id = this.container_id + "_g_" + group.array_index;
            return '<li id="' + group.dom_id + '" class="group-result">' + (label || group.text) + '</li>';
            //} else {
            //    return "";
            //}
        },
        result_add_option: function (option, label, hint) {
            var classes;
            //if (!option.disabled) {
            option.dom_id = this.container_id + "_o_" + option.array_index;
            classes = (option.selected && this.is_multiple) ? [] : (option.disabled ? ["disabled-result"] : ["active-result"]);
            if (option.selected) {
                classes.push("result-selected");
            }
            if (option.group_array_index != null) {
                classes.push("group-option");
            }

            if (option.classes != undefined && option.classes != null) {
                classes.push(option.classes);
            }

            var item;

            if (this.options.renderItem)
                item = this.options.renderItem.call(this, option, label, hint, classes);
            else
                item = '<li id="' + option.dom_id + '" class="' + classes.join(' ') + '" title="' + (hint || label || option.title || option.text) + '">' + (label || option.text) + '</li>';

            return item;
        },
        results_update_field: function () {
            this.result_clear_highlight();
            this.result_single_selected = null;
            return this.results_build();
        },
        result_set_highlight: function (el) {
            if (el.length) {
                this.result_clear_highlight();
                this.result_highlight = el;
                this.result_highlight.addClass("highlighted");
            }
        },

        result_scroll_to_highlight: function () {
            var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
            if (!!this.result_highlight && this.result_highlight.length && this.result_highlight.closest(".chzn-results").length) {

                maxHeight = this.options.customScroll ? this.search_results.parent().height() : parseInt(this.search_results.css("maxHeight"), 10);

                visible_top = this.options.customScroll ? this.scrollbar.customScrollbar('getYPosition') : this.search_results.scrollTop();
                visible_bottom = maxHeight + visible_top;

                high_top = this.result_highlight.position().top + this.search_results.scrollTop();
                high_bottom = high_top + this.result_highlight.outerHeight();

                if (high_bottom >= visible_bottom) {
                    var scrollPos = (high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0;
                    if (this.options.customScroll) {
                        this.updateScroll(scrollPos);
                    }
                    return this.search_results.scrollTop(scrollPos);
                } else if (high_top < visible_top) {
                    var scrollPos = high_top;
                    if (this.options.customScroll) {
                        this.updateScroll(scrollPos);
                    }
                    return this.search_results.scrollTop(scrollPos);
                }
            }
        },

        result_do_highlight: function (el) {
            this.result_set_highlight(el);
            this.result_scroll_to_highlight();
        },
        result_clear_highlight: function () {
            if (this.result_highlight) {
                this.result_highlight.removeClass("highlighted");
            }

            return this.result_highlight = null;
        },
        results_toggle: function (evt) {
            if (this.results_showing) {

                this.results_hide(evt);
            } else {
                this.results_show();
            }
        },
        results_toggle_external: function () {
            if (!this.results_showing)
                $(document).click(this.click_test_action);

            this.results_toggle();
        },
        results_show: function () {

            var _this = this;

            this.results_showing = true;
            this.search_field.val(this.search_field.val());

            this.winnow_results();

            this.container.addClass("open");

            if (!this.is_multiple) {
                this._set_selected_item_state(true);
            }
            if (!this.options.hideDropdownBeforeAdd) {
                this._adjustDropdown();
            }

            if (this.options.showInputForQuickSearch) {
                let canBeFocusedImmediately = this.search_field.closest(":ep-invisible").length === 0;
                if(canBeFocusedImmediately){
                    this.search_field.focus();
                }else{
                    // for some reason instant focus doesn't work because browser still thinks panel is invisible
                    this.search_field.focus();
                }
                
            } else {
                // container always has tabindex=-1 , but selected_item has tabindex the same as source select
                // so if source select was without tabindex then selected_item hasn't tabindex too and we can't 
                // set focus to it. In this case we set focus to container
                // if source select has focus then selected_item has the same tabindex and in this case we can set 
                // focus on it and we need do it to get working navigation on keyboard(tab/shift tab) correctly -> in order which
                // we were specified via tabindexes.
                var $focusKeeper = !(this.selected_item.attr("tabindex")) ? this.container : this.selected_item;
                $focusKeeper.focus();
            }

            this.updateScrollBar();

            if (!this.is_multiple && this.result_single_selected) {
                this.result_do_highlight(this.result_single_selected);
            }

            if (this.options.onShow)
                this.options.onShow();

            return true;
        },

        _adjustDropdown: function(){
            var topInfo = this._calculateDropdownTopPosition();
            this.dropdown.css({
                "top": topInfo.top + "px",
                "display": ''
            });

            if(topInfo.beforeInput){
                this._dropDownBeforeInput = true;
                this.container.addClass("chzn-drop-before-input");
            }else{
                this._dropDownBeforeInput = false;
                this.container.removeClass("chzn-drop-before-input");
            }
        },

        _getViewportTop: function() {
            if (this.options.getViewportTop) {
                return this.options.getViewportTop();
            }
            if (!this.options.isScrollableWindow) {
                const viewportOffset = $(this.options.viewport).offset();
                return viewportOffset ? viewportOffset.top : 0;
            }
            return 0;
        },

        _calculateDropdownTopPosition: function () {
            var inputHeight = this.container.height();

            if(this.options.adjustDropdownContainer){

                var inputOffset = this.container.offset();

                var $viewport = this.options.viewport ? this.container.closest(this.options.viewport) : $(window);

                var realInputTop = inputOffset.top - (this.options.isScrollableWindow ? $viewport.scrollTop() : this._getViewportTop());

                var docHeight = $viewport.height();
                var topViaViewport = Math.min(inputOffset.top - this._getViewportTop(), realInputTop);

                if (((realInputTop + this.dropdown.height() + 30 + inputHeight > docHeight) && (topViaViewport > this.dropdown.height())) || this._adjustDropdownContainerOnlyTop) // check if viewport (default: window) has enough place to display element UP
                {
                    var probablyTopPosition = -1 * this.dropdown.outerHeight() - this.options.spaceBetween;
                    return {
                        top: this.is_multiple ? probablyTopPosition : probablyTopPosition + 1,
                        beforeInput : true
                    };
                }
            }

            var probablyTopPosition = inputHeight + this.options.spaceBetween;

            return {
                top: this.is_multiple ? probablyTopPosition : probablyTopPosition - 1,
                beforeInput: false
            };
        },

        results_hide: function (evt) {
            if (!this.is_multiple) {
                this._set_selected_item_state(false);
            }
            
            this.container.removeClass("open");
            
            this.result_clear_highlight();
            this.dropdown.css({
                "display": "none"
            });

            clearTimeout(this.searching);
            this.results_showing = false;

            //note: keep focus on viewer if close combobox by Esc or by clicking on viewer.
            //      Necessary check whether Esc was pressed in case when combobox is displayed with a search input,
            //      because search input is not ancestor of combobox, so target.closest(item).length = 0
            var keepFocus = this._hideOnSelecting || 
                (evt && (evt.which === ep.Keys.esc || $(evt.target).closest(this.selected_item[0]).length));

            this._trigger("closed", null, {
                keepFocus: keepFocus
            });

            if (this.options.onHide)
                this.options.onHide();

            return false;
        },

        _set_selected_item_state: function(isActive) {
            if(!this.selected_item_active.length) {
                this.selected_item.toggleClass("chzn-single-with-drop", isActive);
                return;
            }
            if(this.options.showDrop) {
                this.selected_item.toggle(!isActive);
            }
            this.selected_item_active.toggle(isActive);
            if (isActive) {
                this.search_field.staticPlaceholder({ ...this.options.placeHolderOptions, text: this.default_text });
            }
        },

        set_tab_index: function (el) {
            if (this.checkDisabled(true))
                return;

            var ti;
            if (this.form_field_jq.attr("tabindex")) {
                ti = this.form_field_jq.attr("tabindex");
                this.form_field_jq.attr("tabindex", -1);
                if (this.is_multiple) {
                    return this.search_field.attr("tabindex", ti);
                } else {
                    this.selected_item.attr("tabindex", ti);
                    return this.search_field.attr("tabindex", -1);
                }
            }
        },
        show_search_field_default: function () {
            if (this.is_multiple && this.choices < 1 && !this.active_field) {
                this.search_field.val(this.default_text);
                return this.search_field.addClass("default");
            } else {
                var searchText = this.options.showInputForQuickSearch ? this.options.initialSearchText : '';
                this.search_field.val(searchText);
                return this.search_field.removeClass("default");
            }
        },

        search_results_click: function (evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).closest(".active-result").first();
            if (target.length) {
                this.result_highlight = target;
                return this.result_select();
            }
        },
        search_results_mouseover: function (evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).closest(".active-result").first();
            if (target) {
                return this.result_do_highlight(target);
            }
        },

        search_results_mouseout: function (evt) {
            if ($(evt.target).hasClass("active-result") || $(evt.target).closest('.active-result').first()) {
                return this.result_clear_highlight();
            }
        },
        choices_click: function (evt) {
            evt.preventDefault();
            if (this.active_field && !($(evt.target).hasClass("search-choice" || $(evt.target).parents('.search-choice').first)) && !this.results_showing) {
                return this.results_show();
            }
        },
        choice_build: function (item) {
            var choice_id, link;
            choice_id = this.container_id + "_c_" + item.array_index;
            this.choices += 1;
            this.search_container.before('<li class="search-choice" id="' + choice_id + '"><span>' + item.text + '</span><a onclick="return false" class="search-choice-close" rel="' + item.array_index + '"></a></li>');
            link = $('#' + choice_id).find("a").first();
            return link.click(__bind(function (evt) {
                return this.choice_destroy_link_click(evt);
            }, this));
        },
        choice_destroy_link_click: function (evt) {
            evt.preventDefault();
            this.pending_destroy_click = true;
            return this.choice_destroy($(evt.target));
        },
        choice_destroy: function (link) {
            this.choices -= 1;
            this.show_search_field_default();
            if (this.is_multiple && this.choices > 0 && this.search_field.val().length < 1) {
                this.results_hide();
            }
            this.result_deselect(link.attr("rel"));
            return link.parents('li').first().remove();
        },

        update_selected_value_from_form_field: function(){
            var val = this.form_field_jq.val();
            //check value of form field is equal to currently selected item in this widget
            if(this.result_single_selected && this.result_single_selected.length){
                var id = this.result_single_selected.attr("id");
                var position = id.substr(id.lastIndexOf("_") + 1);
                var item = this.results_data[position];

                if(item && item.value == val){
                    return;
                }
            }

            for(var i =0; i < this.results_data.length; i++){
                if(this.results_data[i].value === val){

                    if(this.result_single_selected) {
                        this.result_single_selected.removeClass("result-selected");
                    }

                    var itemToSelect = this.results_data[i]
                    itemToSelect.selected = true;
                    this.result_single_selected = $('#' + itemToSelect.dom_id);
                    this.result_single_selected.addClass("result-selected");
                    this.set_selectedText(itemToSelect);
                    this.search_field_scale();

                    break;
                }
            }
        },

        result_select: function () {
            var high, high_id, item, position;
            if (this.result_highlight) {
                if (this.result_highlight.hasClass('chzn-add') ) {
                    if (!this.result_highlight.hasClass('disabled')) {
                        this.add_element();
                    }
                    return;
                }

                high = this.result_highlight;
                high_id = high.attr("id");
                this.result_clear_highlight();
                high.addClass("result-selected");
                if (this.is_multiple) {
                    this.result_deactivate(high);
                } else {
                    this.result_single_selected = high;
                }
                position = high_id.substr(high_id.lastIndexOf("_") + 1);
                item = this.results_data[position];
                item.selected = true;
                this.form_field.options[item.options_index].selected = true;
                if (this.is_multiple) {
                    this.choice_build(item);
                } else {
                    this.set_selectedText(item);
                }

                this.form_field_jq.trigger("change");

                try {
                    this._hideOnSelecting = true;
                    this.results_hide();
                }finally {
                    this._hideOnSelecting = false;
                }
                
                this.search_field.val("");
                this._adjustAddButton("");
                return this.search_field_scale();
            }
        },

        set_selectedText: function (item) {
            var element = this.selected_item.find("span").first();
            var selText = this._getSelectedItemText(item.text);
            var decodedText = $('<div/>').html(selText).text();
            var classToAdd = item.classes != undefined ? item.classes : null;

            element.attr('class', classToAdd);
            
            const selectedItemText = decodedText.replace($.ep.combobox.hierarchyStripper, "");
            element.text(selectedItemText);

            if (this.options.showSelectedItemTitle) {
                element.attr("title", selectedItemText);
            }
        },

        result_activate: function (el) {
            return el.addClass("active-result").show();
        },
        result_deactivate: function (el) {
            return el.removeClass("active-result").hide();
        },
        result_deselect: function (pos) {
            var result, result_data;
            result_data = this.results_data[pos];
            result_data.selected = false;
            this.form_field.options[result_data.options_index].selected = false;
            result = $("#" + this.container_id + "_o_" + pos);
            result.removeClass("result-selected").addClass("active-result").show();
            this.result_clear_highlight();
            this.winnow_results(true);
            this.form_field_jq.trigger("change");
            return this.search_field_scale();
        },
        results_search: function (evt) {
            var self = this;

            clearTimeout(this.searching);
            this.searching = setTimeout(function () {
                self.results_search_do();
            }, 300);
        },
        results_search_do: function () {
            this._adjustDropdownContainerOnlyTop = true;

            if (this.results_showing) {
                this.winnow_results();

            } else {
                this.results_show();
            }

            this._adjustDropdownContainerOnlyTop = false;
        },
        winnow_results: function (force) {
            var searchTextVal = this.search_field.val() === this.default_text ? "" : $.trim(this.search_field.val());
            
            var searchText = _escape(searchTextVal);

            var noItemsInline =  this.options.inlineQuickSearch && !this.results_data.length;
            if (force || searchText !== this.lastSearchText || noItemsInline) {
                this._setContent('', false);

                var self = this;

                var totallyEqualItemFound = false;

                var matcher = new RegExp($.ep.combobox.escapeRegex(searchTextVal), "i");
                
                var filtered_items = $.grep(this.results_data, function (option) {
                    return self._optionIsVisible(option) && matcher.test(_unescape(option.text));
                });

                var showDisabledItems = (filtered_items.length === this.results_data.length);
                var content = '', selected_item;

                var replacer = new RegExp($.ep.combobox.escapeRegex(searchTextVal), "ig");

                for (var _i = 0, _len = filtered_items.length; _i < _len; _i++) {
                    var option = filtered_items[_i];

                    if (!option.empty && (!option.disabled || showDisabledItems)) {
                        var label = option.text;

                        if (!showDisabledItems) {
                            label = label.replace($.ep.combobox.hierarchyStripper, "");
                        }

                        if (searchText) {
                            label = ep.common.highlightTextByRegex(_unescape(label), replacer, ep.common.highlightWrapper);

                            if ($.ep.combobox.caseInsensitiveComparison(option.text, searchText) === 0) {
                                totallyEqualItemFound = true;
                            }
                        }

                        if (option.group) {
                            content += this.result_add_group(option, label);
                        } else {
                            content += this.result_add_option(option, label, option.text);

                            if ((option.selected || !selected_item) && !this.is_multiple) {
                                selected_item = option;
                            }
                        }
                    }
                }

                var addButtonVisible = this._adjustAddButton(searchText, totallyEqualItemFound);
                this._setContent(content, addButtonVisible);          

                if (selected_item) {
                    this.result_single_selected = $('#' + selected_item.dom_id);
                    this.result_set_highlight(this.result_single_selected);
                }
                else if (!!this.add_button.length && !this.add_button.hasClass('disabled')) {
                    this.result_set_highlight(this.add_button);
                } else
                    this.result_clear_highlight();

                if (!this.search_results.text()) {
                    this.no_results(searchTextVal);
                }              

                this.lastSearchText = searchText;
                if (this.lastSearchText && this.options.hideDropdownBeforeAdd) {
                    this._adjustDropdown();
                }
            }

            if(this._dropDownBeforeInput){
                this._adjustDropdown();
            }
            this.updateScrollBar();

            this.result_scroll_to_highlight();

            return true;
        },

        _adjustAddButton: function (text, totallyEqualItemFound) {
            var addButtonVisible = this.addingEnabled() && !!text && !totallyEqualItemFound;

            this.add_button.html(addButtonVisible ? '<div class="add-symbol icon-gray-plus"></div>' + this.options.resources.add + text : '');

            return addButtonVisible;
        },
        _optionIsVisible: function (option) {
            return true;
        },
        winnow_results_clear: function () {
            this.search_field.val("");
        },
        no_results: function (terms) {
            var no_results_html = '';
            if (terms.length) {
                if (!this.addingEnabled()) {
                    var noResultsClass = this.options.noResultsOverflowHidden ? " chzn-overflow-hidden" : "";
                    no_results_html = $('<li class="no-results' + noResultsClass + '">' + this.options.resources.noResultsMatch + '"<span></span>"</li>');
                    no_results_html.find("span").first().text(terms);
                }
            } else {
                no_results_html = this.addingEnabled()
                    ? $('<li class="no-results">' + this.options.resources.keepTyping + '</li>')
                    : $('<li class="no-results">' + this.options.resources.noResults + '</li>');
            }
            this.form_field_jq.trigger('no-result');
            return this.search_results.append(no_results_html);

        },
        no_results_clear: function () {
            return this.search_results.find(".no-results").remove();
        },
        keydown_arrow: function () {
            var first_active, next_sibs, prev_sibs;
            if (!this.result_highlight) {
                first_active = this.search_results.find("li.active-result").first();
                if (first_active.length) {
                    this.result_do_highlight(first_active);
                }
            } else if (this.results_showing) {
                next_sibs = this.result_highlight.nextAll("li.active-result");
                if (next_sibs.length) {
                    this.result_do_highlight(next_sibs.first());
                }
                else {
                    prev_sibs = this.result_highlight.prevAll("li.active-result");
                    if (prev_sibs.length) {
                        this.result_do_highlight(prev_sibs.last());
                    }
                }
            }

            if (!this.results_showing) {
                return this.results_show();
            }
        },
        keyup_arrow: function () {
            var prev_sibs, next_sibs;
            if (!this.results_showing && !this.is_multiple) {
                return this.results_show();
            }
            else if (this.results_showing && !this.is_multiple && !this.result_highlight) {
                var lastActive = this.search_results.find("li.active-result").last();
                if (lastActive.length) {
                    this.result_do_highlight(lastActive);
                }
            }
            else if (this.results_showing && this.result_highlight) {
                prev_sibs = this.result_highlight.prevAll("li.active-result");
                if (prev_sibs.length) {
                    return this.result_do_highlight(prev_sibs.first());
                }
                else if (this.choices > 0) {
                    this.results_hide();
                } else {
                    next_sibs = this.result_highlight.nextAll("li.active-result");
                    if (next_sibs.length) {
                        return this.result_do_highlight(next_sibs.last());
                    }
                }
            }
        },
        keydown_backstroke: function () {
            if (this.pending_backstroke) {
                this.choice_destroy(this.pending_backstroke.find("a").first());
                return this.clear_backstroke();
            } else {
                this.pending_backstroke = this.search_container.siblings("li.search-choice").last();
                return this.pending_backstroke.addClass("search-choice-focus");
            }
        },
        clear_backstroke: function () {
            if (this.pending_backstroke) {
                this.pending_backstroke.removeClass("search-choice-focus");
            }
            return this.pending_backstroke = null;
        },
        keyup_checker: function (evt) {
            if (this.checkDisabled(true))
                return;

            var stroke, _ref;
            stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
            this.search_field_scale();
            switch (stroke) {
                case 8:
                    if (this.is_multiple && this.backstroke_length < 1 && this.choices > 0) {
                        return this.keydown_backstroke();
                    } else if (!this.pending_backstroke) {
                        this.result_clear_highlight();
                        return this.results_search();
                    }
                    break;
                case 13:
                    evt.preventDefault();
                    if (this.results_showing) {
                        return this.result_select();
                    }
                    break;
                case 27:
                    if (this.results_showing) {
                        return this.results_hide(evt);
                    }
                    break;
                case 9:                    
                case 38:
                case 40:
                case 16:
                    break;
                default:
                    return this.results_search();
            }
        },
        keydown_checker: function (evt) {
            if (this.checkDisabled(true))
                return;

            var stroke, _ref;
            stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
            this.search_field_scale();
            if (stroke !== 8 && this.pending_backstroke) {
                this.clear_backstroke();
            }
            switch (stroke) {
                case 8:
                    this.backstroke_length = this.search_field.val().length;
                    break;
                case 9:
                    this.mouse_on_container = false;

                    if (this.results_showing) {                        
                        this.results_hide();
                        return true;
                    }
                    break;
                case 13:
                    if (this.results_showing) {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    break;
                case 27:
                    if (this.results_showing) {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    break;
                case 32:
                    if (!this.options.showInputForQuickSearch) {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                    break;
                case 38:
                    evt.preventDefault();
                    this.keyup_arrow();
                    break;
                case 40:
                    evt.preventDefault();
                    this.keydown_arrow();
                    break;
            }
        },

        add_element: function () {

            var searchTextVal = this.search_field.val() === this.default_text ? "" : $.trim(this.search_field.val());
            //encode search text because we search by text which was encoded too.
            var searchText = $('<div/>').text(searchTextVal).html();

            if (!!searchText) {
                var searchTextItem = find(this.results_data, function (option) {
                    return $.ep.combobox.caseInsensitiveComparison(option.text, searchText) === 0;
                });

                if (!searchTextItem) {
                    this.form_field_jq.append('<option data-chzn-Added = "true" value=' + searchText + '>' + searchText + '</>');
                    this.results_build();
                    var element = this.search_results.find('li:not(.chzn-add)').last();
                    this.result_do_highlight(element);
                    this.result_select();
                }
            }
        },

        search_field_scale: function () {
            var dd_top, div, h, style, style_block, styles, w, _i, _len;
            if (this.is_multiple) {
                h = 0;
                w = 0;
                style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
                styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
                for (_i = 0, _len = styles.length; _i < _len; _i++) {
                    style = styles[_i];
                    style_block += style + ":" + this.search_field.css(style) + ";";
                }
                div = $('<div />', {
                    'style': style_block
                });
                div.text(this.search_field.val());
                $('body').append(div);
                w = div.width() + 25;
                div.remove();
                if (w > this.f_width - 10) {
                    w = this.f_width - 10;
                }
                this.search_field.css({
                    'width': w + 'px'
                });
                dd_top = this.container.height();
                return this.dropdown.css({
                    "top": dd_top + "px"
                });
            }
        },
        generate_field_id: function () {
            var new_id;
            new_id = this.generate_random_id();
            this.form_field.id = new_id;
            return new_id;
        },
        generate_random_id: function () {
            var string;
            string = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();
            while ($("#" + string).length > 0) {
                string += this.generate_random_char();
            }
            return string;
        },
        generate_random_char: function () {
            var chars, newchar, rand;
            chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZ";
            rand = Math.floor(Math.random() * chars.length);
            return newchar = chars.substring(rand, rand + 1);
        },

        updateScroll:function (scrollPos) {
            if (this.scrollbar) {
                this.scrollbar.customScrollbar('update', scrollPos);
            }
        },

        updateScrollBar: function () {
            if (this.scrollbar) {
                this.scrollbar.customScrollbar('updateAndTrySafeCurrentPosition');
            }
        },

        get_selected_item: function(){
            var selectedEl = $("option:selected", this.element);

            return {
                value: selectedEl.val(),
                text: selectedEl.text(),
                isAdded: !!selectedEl.data("chznAdded")
            };
        },

        destroy: function () {
            clearTimeout(this.searching);

            this.container.remove();
            this.element.show();
            $.Widget.prototype.destroy.call(this);
        }
    });

    $.extend($.ep.combobox, {
        get_side_border_padding: function (elmt) {
            return elmt.outerWidth() - elmt.width();
        },
        escapeRegex: function (value) {
            return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
        },
        hierarchyStripper: new RegExp("^[ " + String.fromCharCode(8212) + "]*", "g"),
        caseInsensitiveComparison: function (a, b) {
            var A = a.toUpperCase();
            var B = b.toUpperCase();
            if (A < B) {
                return -1;
            } else if (A > B) {
                return 1;
            } else {
                return 0;
            }
        }
    });

    SelectParser = (function () {
        function SelectParser() {
            this.options_index = 0;
            this.parsed = [];
        };

        SelectParser.prototype.add_node = function (child) {
            if (child.nodeName === "OPTGROUP") {
                return this.add_group(child);
            } else {
                return this.add_option(child);
            }
        };
        SelectParser.prototype.add_group = function (group) {
            var group_position, option, _i, _len, _ref, _results;
            group_position = this.parsed.length;
            this.parsed.push({
                array_index: group_position,
                group: true,
                text: group.label,
                children: 0,
                disabled: group.disabled
            });
            _ref = group.childNodes;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                _results.push(this.add_option(option, group_position, group.disabled));
            }
            return _results;
        };
        SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
            if (option.nodeName === "OPTION") {
                if (option.text !== "") {
                    if (group_position != null) {
                        this.parsed[group_position].children += 1;
                    }

                    var obj = {
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        value: option.value,
                        // Html-encode text
                        text: _escape(option.text),
                        selected: option.selected,
                        disabled: group_disabled === true ? group_disabled : option.disabled,
                        group_array_index: group_position,
                        filters: $.parseJSON(option.getAttribute('data-filters')),
                        classes: $(option).attr('class'),
                        title: $(option).attr('title')
                    };

                    if ($(option).attr('valueitem')) {
                        obj.valueitem = $(option).attr('valueitem');
                    }

                    this.parsed.push(obj);
                } else {
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        empty: true
                    });
                }
                return this.options_index += 1;
            }
        };
        SelectParser.select_to_array = function (select) {
            var child, parser, _i, _len, _ref;
            parser = new SelectParser();
            _ref = select.childNodes;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                child = _ref[_i];
                parser.add_node(child);
            }
            return parser.parsed;
        };
        return SelectParser;
    })();
})(jQuery);

(function ($) {
    var __bind = function (fn, me) {
        return function () {
            return fn.apply(me, arguments);
        };
    };

    $.widget("ep.filteringCombobox", $.ep.combobox, {
        options: {
            filtersWidth: 250,
            customScroll: false,
            spaceBetween: 1
        },
        _create: function () {
            $.ep.combobox.prototype._create.apply(this, arguments);

            var self = this;

            this.filters = $.parseJSON(this.element.attr('data-filters'));

            for (var _i = 0, _len = this.filters.length; _i < _len; _i++) {
                this.filters[_i].filters = [];
            }

            // filling filter items
            for (_i = 0, _len = this.results_data.length; _i < _len; _i++) {
                var item = this.results_data[_i];
                if (!item.disabled && item.filters) {
                    for (var _j = 0, _len2 = this.filters.length; _j < _len2; _j++) {
                        var filterGroup = this.filters[_j];

                        if ($.inArray(item.filters[filterGroup.name], filterGroup.filters) == -1) {
                            filterGroup.filters.push(item.filters[filterGroup.name]);
                        }
                    }
                }
            }

            // checking for emptiness & reordering filter groups
            this.hasFilters = false;
            for (_i = 0, _len = this.filters.length; _i < _len; _i++) {
                if (this.filters[_i].filters.length > 1) {
                    this.hasFilters = true;

                    this.filters[_i].filters.sort($.ep.combobox.caseInsensitiveComparison);
                }
            }

            if (this.hasFilters) {
                this.filtersDiv = $("<div>")
                    .addClass("chzn-filters")
                    .hide();

                this._renderFilterItem(this.filtersDiv, 'All', null);

                for (_i = 0, _len = this.filters.length; _i < _len; _i++) {
                    if (this.filters[_i].filters.length > 1) {
                        this._renderFilterGroupItem(this.filtersDiv, this.filters[_i]);
                    }
                }

                this.filtersDiv.insertAfter(this.dropdown); // todo: investigate why insertAfter changes context

                this.filtersDiv.click(__bind(function (evt) {
                    return this.filters_click(evt);
                }, this));

                this.filter_select(this.filtersDiv.find(".filter-item:first"));
            }
        },
        _renderFilterGroupItem: function (container, filterGroup) {
            $("<div>")
                .addClass("filter-group")
			    .text(filterGroup.title)
			    .appendTo(container);

            var self = this;
            $.each(filterGroup.filters, function (index, filter) {
                self._renderFilterItem(container, filter, { name: filterGroup.name, value: filter });
            });
        },
        _renderFilterItem: function (container, filterTitle, filterObject) {
            var item = $("<div>")
                .addClass("filter-item")
                .data("filter", filterObject);

            if (filterTitle) {
                item.text(filterTitle);
            } else {
                item.html('<i>Not specified</i>');
            }

            item.appendTo(container);
        },
        filters_click: function (evt) {
            if (evt && evt.type === "click") {
                evt.stopPropagation();
            }

            var filter = $(evt.target).hasClass("filter-item") ? $(evt.target) : $(evt.target).parents(".filter-item").first();
            if (filter.length) {
                this.filter_select(filter);
            }

            return this.container_click(evt);
        },
        filter_select: function (item) {
            if (this.filter_selected) {
                this.filter_selected.node.removeClass("selected");
            }

            item.addClass("selected");

            this.filter_selected = { node: item, filter: item.data('filter') };

            if (this.results_showing) {
                return this.winnow_results(true);
            }
        },
        _optionIsVisible: function (option) {
            if (this.filter_selected && this.filter_selected.filter) {
                var currentFilter = this.filter_selected.filter;
                if (option.filters && option.filters[currentFilter.name] !== currentFilter.value) {
                    return false;
                }
            }

            return true;
        },
        results_show: function () {
            var result = $.ep.combobox.prototype.results_show.apply(this, arguments);

            if (this.hasFilters) {
                this.filtersDiv.outerWidth(this.options.filtersWidth)
                    .outerHeight(this.dropdown.outerHeight());

                this.filtersDiv.show();

                this.filtersDiv.position({
                    my: "left top",
                    at: "right top",
                    of: this.dropdown
                });
            }

            return result;
        },
        results_hide: function () {
            var result = $.ep.combobox.prototype.results_hide.apply(this, arguments);

            if (this.hasFilters) {
                this.filtersDiv.hide();
            }

            return result;
        },

        destroy: function () {
            if (this.hasFilters) {
                this.filtersDiv.remove();
            }

            $.ep.combobox.prototype.destroy.call(this);
        }
    });
})(jQuery);

/* eslint-enable */
